export const trustpilotHumanScore = (rating: number): string => {
  if (rating >= 4.3) return "Excellent";
  if (rating >= 3.8) return "Great";
  if (rating >= 2.8) return "Average";
  if (rating >= 1.8) return "Poor";

  return "Bad";
};

export const formatReviews = (value?: number) => {
  if (!value) return "0";

  return new Intl.NumberFormat("en-GB").format(value);
};
